import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DelayedRender, Shimmer } from '@fluentui/react';
import { lazy, Suspense } from 'react';
const LazyEdit = lazy(() => import('./editor').then(c => ({ default: c.MarkdownEditor })));
const LazyView = lazy(() => import('./MarkdownViewer').then(c => ({ default: c.MarkdownViewer })));
/**
 * This is a markdown editor component that manages state and outputs markdown to onChange.
 *
 * @type {FC<import('./editor').MarkdownEditorProps>} props
 */
export const MarkdownEditor = props => (_jsx(Suspense, Object.assign({ fallback: _jsx(Fallback, Object.assign({}, props)) }, { children: _jsx(LazyEdit, Object.assign({}, props)) })));
/**
 * Viewer component that takes markdown and renders it as a react component
 *
 * @type {FC<import('./MarkdownViewer').IMarkdownViewer>}
 */
export const MarkdownViewer = props => (_jsx(Suspense, Object.assign({ fallback: _jsx(Fallback, Object.assign({}, props)) }, { children: _jsx(LazyView, Object.assign({}, props)) })));
/**
 * This is a markdown editor component that manages state and outputs markdown to onChange.
 *
 * @type {FC<import('./editor').MarkdownEditorProps>} props
 */
export default MarkdownEditor;
/**
 * Shimmer view for when the editor is loading
 */
const Fallback = ({ onRenderDescription, errorMessage, className, }) => (_jsxs("div", Object.assign({ className: `msrc-md-editor ${className || ''}` }, { children: [_jsx("div", Object.assign({ className: 'msrc-md-editor--label' }, { children: _jsx(Shimmer, { width: '15em' }) })), _jsx(Shimmer, { width: '88%' }), _jsx(Shimmer, { width: '89%' }), _jsx(Shimmer, { width: '54%' }), _jsx("div", Object.assign({ className: `msrc-md-editor--frame${errorMessage ? ' invalid' : ''}` }, { children: _jsx("div", { className: 'msrc-md-editor--editor-area' }) })), onRenderDescription && (_jsx("div", Object.assign({ className: 'msrc-md-editor--description' }, { children: onRenderDescription() }))), errorMessage && (_jsx("div", Object.assign({ role: 'alert' }, { children: _jsx(DelayedRender, { children: _jsx("p", Object.assign({ className: 'msrc-md-editor--error-message' }, { children: _jsx("span", Object.assign({ "data-automation-id": 'error-message' }, { children: errorMessage })) })) }) })))] })));
